import { useEffect, useState } from "react";
import * as Scrivito from "scrivito";
import { useUser } from "stores/user";
import type { DocumentsState } from "interfaces/product/product.types";
import { useLanguage } from "stores/globalStore";

export const useFetchScrivitoDocumentsForProduct = ({
  seriesId = null,
}: {
  seriesId: number | null;
}) => {
  const [documents, setDocuments] = useState<DocumentsState>({
    certificates: [],
    productInfo: [],
    manuals: [],
  });

  const lang = useLanguage();

  const user = useUser();

  useEffect(() => {
    async function loadManuals() {
      const obj: Scrivito.Obj | null = seriesId
        ? await Scrivito.load(() =>
            Scrivito.Obj.where("_objClass", "equals", "ProductSeries")
              .and("epfId", "equals", seriesId?.toString())
              .and("categoryLanguages", "equals", lang)
              .and("categoryClients", "equals", user?.tenant as string)
              .and("categoryOwner", "equals", "SC")
              .first(),
          )
        : null;

      if (obj) {
        const docs = (await Scrivito.load(() =>
          obj.get("documents"),
        )) as Scrivito.Obj[];

        const categorizedDocs: DocumentsState = {
          certificates: [],
          productInfo: [],
          manuals: [],
        };

        docs?.forEach((doc) => {
          const category = doc.get("categoryDownloadType");
          const categoryLanguages = doc.get("categoryLanguages") as string[];
          const categoryClients = doc.get("categoryClients") as string[];

          if (
            categoryLanguages?.includes(lang) &&
            categoryClients?.includes(user?.tenant as string)
          ) {
            if (category === "certificates") {
              categorizedDocs.certificates.push(doc);
            } else if (category === "product_info") {
              categorizedDocs.productInfo.push(doc);
            } else if (category === "manuals") {
              categorizedDocs.manuals.push(doc);
            }
          }
        });

        setDocuments(categorizedDocs);
      } else {
        setDocuments({
          certificates: [],
          productInfo: [],
          manuals: [],
        });
      }
    }

    loadManuals();
  }, [seriesId, lang, user]);

  return { documents };
};
